import { Typography, Box, Paper, CircularProgress } from '@mui/material';
import React, { useState, useEffect } from 'react';

import FormSection from 'application/components/FormSection/FormSection';
import useOrgData from 'application/hooks/useOrgData';
import {
  FieldLabel,
  StyledButton,
  StyledTextField,
} from './configurationForms/styledFormComponents';
import _ from 'lodash';
import { GamifyToast } from 'application/common/CustomToasts';

export default function GeneralOrgConfig() {
  const [org, setOrg] = useState<any>(null);
  const [hasChanged, setHasChanged] = useState<boolean>(false);
  const { orgData, updateOrgData } = useOrgData();

  useEffect(() => {
    if (orgData) {
      setOrg(orgData);
    }
  }, [orgData]);

  useEffect(() => {
    if (!_.isEqual(org, orgData)) {
      setHasChanged(true);
    } else if (hasChanged) {
      setHasChanged(false);
    }
  }, [org]);

  const handleSubmit = async () => {
    const res = await updateOrgData({
      id: org.id,
      name: org.name,
      contactPhone: org.contactPhone,
      contactEmail: org.contactEmail,
      contactAddress: org.contactAddress,
      contactAddress2: org.contactAddress2,
      contactCity: org.contactCity,
      contactState: org.contactState,
      contactZip: org.contactZip,
      contactName: org.contactName,
    });
    if (res) {
      setHasChanged(false);
      //   setOrg(orgData);
      GamifyToast.success('Org data updated successfully');
    } else {
      GamifyToast.error('Error updating org data');
    }
  };
  if (!org) {
    return <CircularProgress color="inherit" />;
  }

  return (
    // <Box style={{ minHeight: '80vh' }}>
    <Paper
      elevation={0}
      sx={(theme) => ({
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme.custom?.background1,
        borderRadius: '16px',
        marginBottom: 2,
      })}
    >
      <Typography
        sx={(theme) => ({
          fontWeight: 780,
          fontSize: 20,
          color: theme.custom?.text,
        })}
      >
        General Information
      </Typography>
      <Typography
        sx={(theme) => ({
          fontWeight: 400,
          fontSize: 15,
          color: theme.custom?.textLight,
          marginBottom: 2,
        })}
      >
        {`Customize general information for your organization.`}
      </Typography>
      {/* </FormSection> */}
      <FormSection>
        <Box sx={{ gap: 1, display: 'flex', flexDirection: 'column' }}>
          <Box>
            <FieldLabel>Name</FieldLabel>
            <StyledTextField
              fullWidth
              value={org.name}
              onChange={(e) => setOrg({ ...org, name: e.target.value })}
            />
            {org.name === '' && (
              <Typography color="#AE1414" fontSize={12} sx={{ marginLeft: 1 }}>
                Name is required
              </Typography>
            )}
          </Box>
          <Box>
            <FieldLabel>Contact Phone</FieldLabel>
            <StyledTextField
              fullWidth
              value={org.contactPhone}
              onChange={(e) => setOrg({ ...org, contactPhone: e.target.value })}
            />
          </Box>
          <Box>
            <FieldLabel>Contact Email</FieldLabel>
            <StyledTextField
              fullWidth
              value={org.contactEmail}
              onChange={(e) => setOrg({ ...org, contactEmail: e.target.value })}
            />
          </Box>
          <Box>
            <FieldLabel>Address</FieldLabel>
            <StyledTextField
              fullWidth
              value={org.contactAddress}
              onChange={(e) =>
                setOrg({ ...org, contactAddress: e.target.value })
              }
            />
          </Box>
          <Box>
            <FieldLabel>Address 2</FieldLabel>
            <StyledTextField
              fullWidth
              value={org.contactAddress2}
              onChange={(e) =>
                setOrg({ ...org, contactAddress2: e.target.value })
              }
            />
          </Box>
          <Box>
            <FieldLabel>City</FieldLabel>
            <StyledTextField
              fullWidth
              value={org.contactCity}
              onChange={(e) => setOrg({ ...org, contactCity: e.target.value })}
            />
          </Box>
          <Box>
            <FieldLabel>State</FieldLabel>
            <StyledTextField
              fullWidth
              value={org.contactState}
              onChange={(e) => setOrg({ ...org, contactState: e.target.value })}
            />
          </Box>
          <Box>
            <FieldLabel>Zip</FieldLabel>
            <StyledTextField
              fullWidth
              value={org.contactZip}
              onChange={(e) => setOrg({ ...org, contactZip: e.target.value })}
            />
          </Box>
        </Box>
      </FormSection>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 1,
          marginLeft: 'auto',
          minWidth: '600px',
          paddingRight: 2,
          paddingTop: 2,
        }}
      >
        {/* <SecondaryButton
          variant="outlined"
          disabled={!hasChanged}
          onClick={handleResetOrg}
        >
          Reset Form
        </SecondaryButton> */}
        <StyledButton
          disabled={!hasChanged && org.name !== ''}
          onClick={handleSubmit}
        >
          Save Changes
        </StyledButton>
      </Box>
    </Paper>
    // </Box>
  );
}
